import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-131">
      <FadeIn data-id="element-132">
        <div className="bg-[#1f1b16] rounded-[2.5rem] p-8 md:p-16 border border-[#7c3aed]/30 shadow-[0_20px_50px_rgba(31,27,22,0.15)] relative overflow-hidden" data-id="element-133">
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#7c3aed_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-134"></div>

          <div className="relative z-10" data-id="element-135">
            <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-[#e7dfce] text-[28px]" data-id="element-136">
              El siguiente ataque de pánico, la siguiente noche sin dormir, el
              siguiente día destruido por el agotamiento pueden ser diferentes.
              🎵
            </h2>

            <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-137">
              {/* Option 1 */}
              <a href="https://tumanualdigital.com/cart/44193380892708:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-[#0f0d09] border border-[#7c3aed]/30 rounded-2xl hover:border-[#7c3aed] transition-colors group pt-[0px] pb-[0px]" data-id="element-138">
                <div className="text-left mb-4 sm:mb-0" data-id="element-139">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-140">
                    <span data-id="element-141">📘</span> BOTIQUÍN VIBRACIONAL PRO
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-142">
                    <span className="text-[#ef4444] line-through text-sm font-bold" data-id="element-143">
                      $150.000
                    </span>
                    <span className="text-2xl font-black text-white" data-id="element-144">
                      $19.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#1f1b16] text-[#7c3aed] font-black py-3 px-6 rounded-xl group-hover:bg-[#2d2822] transition-colors w-full sm:w-auto text-center border border-[#7c3aed]/30" data-id="element-145">
                  → QUIERO MI BOTIQUÍN VIBRACIONAL PRO
                </div>
              </a>

              {/* Option 2 */}
              <a href="https://tumanualdigital.com/cart/44193381122084:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-[#7c3aed]/20 to-[#0f0d09] border-2 border-[#7c3aed] rounded-2xl hover:shadow-[0_0_30px_rgba(124,58,237,0.3)] transition-all group relative overflow-hidden" data-id="element-146">
                <div className="absolute top-0 right-0 bg-[#7c3aed] text-[#0f0d09] text-xs font-black px-3 py-1 rounded-bl-lg" data-id="element-147">
                  ⭐ MÁS ELEGIDO
                </div>
                <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-148">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-149">
                    <span data-id="element-150">🏆</span> BOTIQUÍN VIBRACIONAL PRO + LABORATORIO PRO
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-151">
                    <span className="text-[#ef4444] line-through text-sm font-bold" data-id="element-152">
                      $220.000
                    </span>
                    <span className="text-2xl font-black text-[#7c3aed]" data-id="element-153">
                      $27.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#7c3aed] text-[#0f0d09] font-black py-3 px-6 rounded-xl group-hover:bg-[#a78bfa] transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-154">
                  → QUIERO EL BOTIQUÍN + LABORATORIO PRO
                </div>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-[#e7dfce] font-bold" data-id="element-155">
              <span className="flex items-center gap-1.5" data-id="element-156">
                <Lock size={16} className="text-[#7c3aed]" data-id="element-157" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-158">
                <Zap size={16} className="text-[#7c3aed]" data-id="element-159" /> Acceso en 5 min
              </span>
              <span className="flex items-center gap-1.5" data-id="element-160">
                <Shield size={16} className="text-[#7c3aed]" data-id="element-161" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-[#6b6358] font-medium" data-id="element-162">
              <span className="flex items-center gap-1.5" data-id="element-163">
                <CreditCard size={16} data-id="element-164" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}